module.exports = __webpack_public_path__ + "a5183906febd54fecb86779a3d04594d.png";